import { render, staticRenderFns } from "./DiagnosticosSinValidar.vue?vue&type=template&id=ae87d642"
import script from "./DiagnosticosSinValidar.vue?vue&type=script&lang=js"
export * from "./DiagnosticosSinValidar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports